<div class="pending-session-container">
  <div class="header-section">
    <h1>Pending Sessions</h1>
  </div>

  <div class="search-section">
    <p-iconfield iconPosition="left">
      <p-inputicon>
        <i class="pi pi-search"></i>
      </p-inputicon>
      <input 
        type="text" 
        pInputText 
        placeholder="Search sessions..." 
        (keyup)="sendFilterQuery($event)"
        [(ngModel)]="searchFilter"
        class="search-input" />
    </p-iconfield>
  </div>

  <div class="table-section">
    <app-besharp-table
      [tableItems]="sessions"
      [loading]="loading"
      [tableDefinitions]="tableDefinitions"
      [actionDefinitions]="baseActionDefinitions"
      [showActionsAsButtons]="true"
      [totalRecords]="totalCount"
      [pageRows]="10"
      [paginator]="true"
      [defaultActive]="'a'"
      [defaultDirection]="-1"
      [idColumnDef]="'id'"
      [showGridLines]="true"
      [pageRowsOptions]="[5, 10, 20]"
      [showStripes]="true"
      [idColumnDef]="'id'"
      [rowOverEffect]="true"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} sessions'"
      [showClearFiltersButton]="false"
      (rowClicked)="onRowClicked($event)"
      styleClass="custom-table"
    >
    </app-besharp-table>
  </div>

  <p-dialog
    [(visible)]="showNotesModal"
    header="Stop Session"
    [modal]="true"
    [closable]="!stoppingSession"
    [draggable]="false"
    [resizable]="false"
    styleClass="notes-modal"
    [style]="{ width: '500px' }"
  >
    <div class="modal-content">
      <p class="modal-description">
        Please enter a note for stopping session <strong>{{ sessionToStop?.sessionId }}</strong>
      </p>
      
      <div class="field">
        <label for="notes">Notes *</label>
        <textarea
          id="notes"
          pInputTextarea
          [(ngModel)]="notesValue"
          rows="3"
          placeholder="Enter reason for stopping..."
          [disabled]="stoppingSession"
          class="notes-textarea"
        ></textarea>
        <small *ngIf="notesValue.trim() === ''" class="p-error">Note is required.</small>
      </div>
    </div>
    
    <ng-template pTemplate="footer">
      <div class="modal-footer">
        <p-button
          label="Cancel"
          icon="pi pi-times"
          [text]="true"
          (onClick)="cancelStop()"
          [disabled]="stoppingSession"
        ></p-button>
        <p-button
          [label]="stoppingSession ? 'Stopping...' : 'Confirm'"
          [icon]="stoppingSession ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
          (onClick)="confirmStop()"
          [disabled]="notesValue.trim() === '' || stoppingSession"
          [loading]="stoppingSession"
        ></p-button>
      </div>
    </ng-template>
  </p-dialog>

<!--  <p-dialog-->
<!--    [(visible)]="showResolutionModal"-->
<!--    header="Select Resolution"-->
<!--    [modal]="true"-->
<!--    [closable]="!connecting"-->
<!--    [draggable]="false"-->
<!--    [resizable]="false"-->
<!--    styleClass="resolution-modal"-->
<!--    [style]="{ width: '500px' }"-->
<!--  >-->
<!--    <div class="modal-content">-->
<!--      <p class="modal-description">-->
<!--        Select a resolution for session <strong>{{ sessionToConnect?.sessionId }}</strong>-->
<!--      </p>-->
<!--      -->
<!--      <div class="field">-->
<!--        <label for="resolution">Resolution *</label>-->
<!--        <div class="resolution-options">-->
<!--          @for(option of resolutionOptions; track option.label) {-->
<!--          <div class="resolution-option"-->
<!--               [class.selected]="selectedResolution === option"-->
<!--               (click)="!connecting && (selectedResolution = option)">-->
<!--            <i class="pi" [class.pi-circle]="selectedResolution !== option" [class.pi-check-circle]="selectedResolution === option"></i>-->
<!--            <span>{{ option.label }}</span>-->
<!--          </div>-->
<!--          }-->
<!--        </div>-->
<!--      </div>-->

<!--      <div *ngIf="connecting && connectionAttempt > 0" class="connection-status">-->
<!--        <i class="pi pi-spin pi-spinner"></i>-->
<!--        <span>Connecting... (Attempt {{ connectionAttempt }})</span>-->
<!--      </div>-->
<!--    </div>-->
<!--    -->
<!--    <ng-template pTemplate="footer">-->
<!--      <div class="modal-footer">-->
<!--        <p-button-->
<!--          label="Cancel"-->
<!--          icon="pi pi-times"-->
<!--          [text]="true"-->
<!--          (onClick)="cancelResolutionSelection()"-->
<!--          [disabled]="connecting"-->
<!--        ></p-button>-->
<!--        <p-button-->
<!--          [label]="connecting ? 'Connecting...' : 'Connect'"-->
<!--          [icon]="connecting ? 'pi pi-spin pi-spinner' : 'pi pi-check'"-->
<!--          (onClick)="confirmConnect()"-->
<!--          [disabled]="!selectedResolution || connecting"-->
<!--          [loading]="connecting"-->
<!--        ></p-button>-->
<!--      </div>-->
<!--    </ng-template>-->
<!--  </p-dialog>-->
</div>

<p-toast position="bottom-center"></p-toast>
